/* Shared presentation and explicit edition previews. No pricing/cart mutation. */
(() => {
 'use strict';
 const source=document.currentScript;
 const seasonsURL=source?.dataset.seasons;
 const root=document.documentElement;
 const ar=root.lang.startsWith('ar');
 const text=(en,arabic)=>ar?arabic:en;
 const valid=['regular','national-day','founding-day','ramadan','eid-fitr','eid-adha','summer','winter','white-friday','new-year'];
 const current=new URL(location.href);
 const explicit=current.searchParams.get('klik_design')||current.searchParams.get('view');
 const preview=current.searchParams.get('klik_preview')==='1';
 function copy(element,values){
  if(!element||!values)return;
  const target=element.querySelector(':scope > [data-klik-i18n-en]')||element;
  target.dataset.klikI18nEn=values[0];target.dataset.klikI18nAr=values[1];target.setAttribute('data-wg-notranslate','');target.textContent=values[ar?1:0];
 }
 function information(){
  document.querySelectorAll('.ki-reading>.rte,.shopify-policy__body>.rte').forEach(content=>{
   if(content.dataset.ksReading)return;content.dataset.ksReading='true';
   const headings=[...content.children].filter(e=>e.tagName==='H2');
   if(headings.length<2)return;
   const page=content.closest('[data-info-page]')?.dataset.infoPage||'';
   const faq=/faq/.test(page);
   let group=null;
   for(const child of [...content.childNodes]){
    if(child.nodeType===1&&child.tagName==='H2'){
     const index=headings.indexOf(child);const id=child.id||'information-'+index;
     if(faq){
      const details=document.createElement('details');details.className='ks-faq';details.id=id;
      const summary=document.createElement('summary');summary.textContent=child.textContent;details.append(summary);
      group=document.createElement('div');details.append(group);child.replaceWith(details);
     }else{
      const section=document.createElement('section');section.className='ks-information-group';section.setAttribute('aria-labelledby',id);child.id=id;child.before(section);section.append(child);group=section;
     }
    }else if(group){group.append(child);}
   }
   if(!faq&&headings.length>3){
    const nav=document.createElement('nav');nav.className='ks-contents';nav.setAttribute('aria-label',text('On this page','في هذه الصفحة'));
    headings.forEach(heading=>{const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;nav.append(link);});content.before(nav);nav.style.gridColumn='1 / -1';
   }
  });
 }
 async function edition(){
  requestAnimationFrame(()=>requestAnimationFrame(()=>{const meta=document.querySelector('meta[name="theme-color"]');if(meta)meta.content=getComputedStyle(root).getPropertyValue('--ks-deep').trim();}));
  if(!preview&&!document.querySelector('.khx-hero'))return;
  if(!seasonsURL)return;
  try{
   const response=await fetch(seasonsURL,{credentials:'omit',cache:'force-cache'});if(!response.ok)return;
   const seasons=await response.json();const season=seasons[root.dataset.klikDesign]||seasons.regular;
   copy(document.querySelector('.khx-hero__title>.khx-eyebrow'),season.eyebrow);
   const title=document.querySelector('.khx-hero h1');
   if(title){copy(title.querySelector(':scope > span'),season.title);copy(title.querySelector('em'),season.accent);}
   copy(document.querySelector('.khx-hero__intro>p'),season.intro);
   if(preview){
    const panel=document.createElement('aside');panel.className='ks-edition-preview';panel.setAttribute('aria-label',text('Design preview','معاينة التصميم'));
    const label=document.createElement('label');label.htmlFor='KsEdition';label.textContent=text('Design preview','معاينة التصميم');
    const select=document.createElement('select');select.id='KsEdition';
    Object.entries(seasons).forEach(([key,value])=>{const option=document.createElement('option');option.value=key;option.textContent=ar?value.arLabel:value.label;option.selected=key===root.dataset.klikDesign;select.append(option);});
    select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('klik_design',select.value);if(['regular','national-day'].includes(url.searchParams.get('view')))url.searchParams.delete('view');location.assign(url.href);});
    panel.append(label,select);document.body.append(panel);
   }
  }catch(_){/* Server-rendered content remains complete if the optional edition file fails. */}
 }
 // Retain a deliberate review choice as the reviewer browses; ordinary customers use the merchant setting.
 if(valid.includes(explicit))document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');if(!link||link.target==='_blank')return;
  let url;try{url=new URL(link.href,location.href);}catch(_){return;}
  if(!['klikdecor.com','ar.klikdecor.com',location.hostname].includes(url.hostname))return;
  if(!/^\/(?:products|collections|pages|blogs|cart|search|policies)(?:\/|$)/.test(url.pathname)&&url.pathname!=='/')return;
  if(/\/pages\/(?:order-team|showroom-studio)/.test(url.pathname))return;
  url.searchParams.set('klik_design',explicit);if(preview)url.searchParams.set('klik_preview','1');link.href=url.href;
 },true);
 function gallery(){
 document.querySelectorAll('.kpd-gallery .product__thumbs--scroller').forEach(scroller=>{
   const main=scroller.closest('.product__photos')?.querySelector('.product__main-photos');
   let fitQueued=false;
   const fit=()=>{
    fitQueued=false;
    const frame=main?.querySelector('.flickity-viewport'),slide=main?.querySelector('.product-main-slide.is-selected');
    if(frame&&slide&&slide.offsetHeight&&Math.abs(frame.offsetHeight-slide.offsetHeight)>1)frame.style.height=slide.offsetHeight+'px';
   };
   const queueFit=()=>{if(!fitQueued){fitQueued=true;requestAnimationFrame(fit);}};
   const reveal=()=>{
    queueFit();
    if(!matchMedia('(max-width:767px)').matches)return;
    const active=scroller.querySelector('.product__thumb.is-active');if(!active)return;
    const thumb=active.getBoundingClientRect(),rail=scroller.getBoundingClientRect();
    if(thumb.left<rail.left||thumb.right>rail.right)scroller.scrollLeft+=thumb.left-rail.left-(rail.width-thumb.width)/2;
   };
   new MutationObserver(reveal).observe(scroller,{subtree:true,attributes:true,attributeFilter:['class']});
   if(main)new ResizeObserver(queueFit).observe(main);
  });
 }
 const ready=()=>{information();edition();gallery();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
